import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import car from "../../assets/images/car4.jpg";
import heroPhoto from "../../assets/images/assa.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Fahrzeugübersicht.css";
import HeroSection from "../heroSection/HeroSection";
import ShipmentAndVehicles from "../vehicleSection/ShipmentAndVehicles";
import Footer from "../footer/Footer";
import LandingSection from "../landingSection/LandingSection";
import NavbarMenu from "../heroSection/NavbarMenu";
import { useTranslation } from "react-i18next";
import SEO from "../SEO";

const Fahrzeugübersicht = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <SEO
        title="TransCirox – Kurierfahrzeuge & Fahrzeugübersicht | Transportfahrzeuge buchen"
        description="Entdecken Sie unsere vielfältige Flotte: Kurierwagen, Transporter und mehr. Buchen Sie das passende Fahrzeug für Ihren Transport bei TransCirox."
        keywords="Kurierfahrzeug, Kurierwagen, Transporter, Fahrzeugtransport, Transportfahrzeuge, Kuriertransport"
      />
      <NavbarMenu />

      {/* Hero Section */}
      <LandingSection
        backgroundImage={heroPhoto}
        customHeight="90vh"
        showTopbar={false}
        showQuoteForm={false}
        showCTAButton={true}
      >
        <div className="text-white header-content" data-aos="fade-down">
          <h6 className="display-4 fw-bold landing-title">
            <span className="typing-word text-orange">
              {t("Fahrzeugübersicht.hero_title")}
            </span>
          </h6>

          <div className="landing-list">
            <p className="fw-bold text-end text-white">
              {t("Fahrzeugübersicht.hero_breadcrumb")}
            </p>
          </div>
        </div>
      </LandingSection>

      <section className="service-section py-5 bg-light">
        {/* Section Title */}
        <section
          className="text-center mission-section mb-4"
          data-aos="fade-up"
        >
          <Container>
            <h4 className="fw-bold text-white">{t("Fahrzeugübersicht.section_title")}</h4>
          </Container>
        </section>

        {/* Content Section */}
        <Container fluid className="px-4 px-md-5 py-5">
          <Row className="align-items-center gy-4" data-aos="fade-up">
            {/* Vehicle Types */}
            <Col md={6} data-aos="fade-right">
              {/* Caddy */}
              <div className="mb-3 p-3 bg-white shadow-sm rounded-4">
                <h6 className="text-orange mb-2 fw-semibold small text-uppercase">
                  {t("Fahrzeugübersicht.caddy.title")}
                </h6>
                <p className="mb-1 small">
                  <strong>{t("Fahrzeugübersicht.caddy.usage_label")}:</strong>{" "}
                  {t("Fahrzeugübersicht.caddy.usage")}
                </p>
                <p className="mb-1 small">
                  <strong>
                    {t("Fahrzeugübersicht.caddy.capacity_label")}:
                  </strong>{" "}
                  {t("Fahrzeugübersicht.caddy.capacity")}
                </p>
                <p className="mb-0 small">
                  <strong>
                    {t("Fahrzeugübersicht.caddy.advantages_label")}:
                  </strong>{" "}
                  {t("Fahrzeugübersicht.caddy.advantages")}
                </p>
              </div>

              {/* Bus */}
              <div className="mb-3 p-3 bg-white shadow-sm rounded-4">
                <h6 className="text-orange mb-2 fw-semibold small text-uppercase">
                  {t("Fahrzeugübersicht.bus.title")}
                </h6>
                <p className="mb-1 small">
                  <strong>{t("Fahrzeugübersicht.bus.usage_label")}:</strong>{" "}
                  {t("Fahrzeugübersicht.bus.usage")}
                </p>
                <p className="mb-1 small">
                  <strong>{t("Fahrzeugübersicht.bus.capacity_label")}:</strong>{" "}
                  {t("Fahrzeugübersicht.bus.capacity")}
                </p>
              </div>

              {/* Maxi Bus */}
              <div className="mb-3 p-3 bg-white shadow-sm rounded-4">
                <h6 className="text-orange mb-2 fw-semibold small text-uppercase">
                  {t("Fahrzeugübersicht.maxi_bus.title")}
                </h6>
                <ul className="ps-3 mb-0 small">
                  <li>
                    <strong>
                      {t("Fahrzeugübersicht.maxi_bus.flexibility_label")}:
                    </strong>{" "}
                    {t("Fahrzeugübersicht.maxi_bus.flexibility")}
                  </li>
                  <li>
                    <strong>
                      {t("Fahrzeugübersicht.maxi_bus.capacity_label")}:
                    </strong>{" "}
                    {t("Fahrzeugübersicht.maxi_bus.capacity")}
                  </li>
                  <li>
                    <strong>
                      {t("Fahrzeugübersicht.maxi_bus.efficiency_label")}:
                    </strong>{" "}
                    {t("Fahrzeugübersicht.maxi_bus.efficiency")}
                  </li>
                </ul>
              </div>

              {/* Planenbus */}
              <div className="p-3 bg-white shadow-sm rounded-4">
                <h6 className="text-orange mb-2 fw-semibold small text-uppercase">
                  {t("Fahrzeugübersicht.planenbus.title")}
                </h6>
                <p className="mb-1 small">
                  <strong>
                    {t("Fahrzeugübersicht.planenbus.capacity_label")}:
                  </strong>{" "}
                  {t("Fahrzeugübersicht.planenbus.capacity")}
                </p>
                <ul className="ps-3 mb-0 small">
                  <li>
                    <strong>
                      {t(
                        "Fahrzeugübersicht.planenbus.increased_capacity_label",
                      )}
                      :
                    </strong>{" "}
                    {t("Fahrzeugübersicht.planenbus.increased_capacity")}
                  </li>
                  <li>
                    <strong>
                      {t("Fahrzeugübersicht.planenbus.flexibility_label")}:
                    </strong>{" "}
                    {t("Fahrzeugübersicht.planenbus.flexibility")}
                  </li>
                  <li>
                    <strong>
                      {t("Fahrzeugübersicht.planenbus.efficiency_label")}:
                    </strong>{" "}
                    {t("Fahrzeugübersicht.planenbus.efficiency")}
                  </li>
                </ul>
              </div>
            </Col>
            {/* Image */}
            <Col
              md={6}
              data-aos="fade-left"
              className="text-center mb-4 mb-md-0"
            >
              <img
                src={car}
                alt="car"
                className="rounded shadow img-fluid car-img"
              />
            </Col>
          </Row>

          {/* Vehicle Cards Section */}
          <div className="pt-5">
            <ShipmentAndVehicles hideHeader />
          </div>
        </Container>
      </section>

      <Footer />
    </>
  );
};

export default Fahrzeugübersicht;
